module.exports = __webpack_public_path__ + "img/sdg9_jp.1e05defa.png";